var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup),expression:"showPopup"}],staticClass:"loading"},[_c('van-loading',{attrs:{"size":"25px","type":"spinner","text-size":"15px","color":"#fff"}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }